// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".v-item-group[data-v-4bc22684] {\n  margin: 0 10px;\n  overflow: visible;\n}", "",{"version":3,"sources":["/home/gitlab-runner/builds/fQP2DYKmz/0/greenywave/greenycloud-administrador/src/views/user/UserHome.vue"],"names":[],"mappings":"AACA;EACE,cAAA;EACA,iBAAA;AAAF","file":"UserHome.vue","sourcesContent":["\n.v-item-group {\n  margin: 0 10px;\n  overflow: visible;\n}\n"]}]);
// Exports
module.exports = exports;
